import { render, staticRenderFns } from "./Unconfirmed.vue?vue&type=template&id=788b3cc2&"
import script from "./Unconfirmed.vue?vue&type=script&lang=js&"
export * from "./Unconfirmed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports